import React from "react";
import ServerPaginatedTable from "../utils/pagination.server";
import moment from "moment";
import PdfIcon from "react-icons/lib/md/picture-as-pdf";
import ExcelIcon from "react-icons/lib/md/insert-drive-file";
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import ReportIcon from "react-icons/lib/ti/clipboard";
import { appHelpers, store } from "../../_helpers";
import MdEdit from "react-icons/lib/md/edit";
import { history } from "../../_helpers";

const DataTable = ({ data, downloadPdf, downloadExcel }) => {
  const { authentication } = store.getState();
  const currentUser = authentication.user.userName;
  const handleEditClick = (record) => {
    history.push({
      pathname: `/pdm-edit/`,
      state: { record },
    });
  };
  return data.Results.length === 0 ? (
    <PageEmptyContent message="No record match your search!" />
  ) : (
    <div className="view">
      <div className="row">
        <div className="col-sm-6">
          <h5 className="font-weight-normal mb-2">
            <ReportIcon size="22" color="#43a8df" />
            {appHelpers.numberWithCommasOnly(data.TotalCount)} records matched
          </h5>
        </div>
        {/*Files to be downloaded*/}
        <div className="col-sm-6">
          <div className="text-right" style={{ marginBottom: "20px" }}>
            <strong>Download: </strong>
            <span className="pointer" onClick={downloadPdf}>
              <ToolTipItem
                key={"downloadPdfIcon"}
                title={
                  <PdfIcon
                    size="18"
                    color="#e53335"
                    className="icon-picture-as-pdf"
                  />
                }
                content="Download PDF"
                id={"downloadPdfIcon"}
              />
            </span>
            &nbsp;
            <span className="pointer" onClick={downloadExcel}>
              <ToolTipItem
                key={"downloadExcelIcon"}
                title={
                  <ExcelIcon
                    size="18"
                    color="#5ead57"
                    className="icon-insert-drive-file"
                  />
                }
                content="Download Excel"
                id={"downloadExcelIcon"}
              />
            </span>
          </div>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>
                <span>Airline</span>
              </th>
              <th>
                <span>Flight No/Route</span>
              </th>
              <th>
                <span>Pax Count</span>
              </th>
              <th>
                <span>PDM Pax Count</span>
              </th>
              <th>
                <span>Flight Date</span>
              </th>
              <th>
                <span>Variance</span>
              </th>
              <th>
                <span>PDM Logged By</span>
              </th>
              <th>
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.Results.map((record, i) => (
              <tr key={i + 1}>
                <td className="text-capitalize">{record.AirlineName}</td>
                <td>{record.FlightNumberCode}</td>
                <td>{record.ManifestPAX === null ? "" : record.ManifestPAX}</td>
                <td>{record.PdmPAX === null ? "" : record.PdmPAX}</td>
                <td>{moment(record.DepartureDate).format("MMM Do YYYY")}</td>
                <td
                  className="text-capitalize"
                  style={{ color: record.Variance === 0 ? "green" : "red" }}
                >
                  {record.Variance}
                </td>
                <td>{record.PdmCreatedBy}</td>
                {/* <td>
                                    {record.PdmCreatedBy === currentUser && (
                                        <span
                                            className="pointer"
                                            onClick={() => handleEditClick(record)}
                                            style={{ color: 'blue' }}
                                        >
                                            <MdEdit size="20" />
                                        </span>
                                    )}
                                </td> */}
                <td>
                  {record.PdmCreatedBy === currentUser ? (
                    <span
                      className="pointer"
                      onClick={() => handleEditClick(record)}
                      style={{ color: "blue" }}
                    >
                      <MdEdit size="20" />
                    </span>
                  ) : (
                    <span style={{ color: "#999", fontStyle: "italic" }}>
                      N/A
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

class PaginatedResult extends React.Component {
  render() {
    const {
      downloadPdf,
      downloadExcel,
      pageSize,
      currentPage,
      totalCount,
      navigate,
      pdmResults,
    } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12 mb-4">
            <ServerPaginatedTable
              currentPage={currentPage}
              fetchMore={navigate}
              target={
                <DataTable
                  downloadPdf={downloadPdf}
                  downloadExcel={downloadExcel}
                  data={pdmResults}
                />
              }
              pageSize={pageSize}
              totalCount={totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PaginatedResult;



// WEBPACK FOOTER //
// ./src/views/pdm-report/pdm-result.js